import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib';
import { usePartner } from '@shared/lib/partner';
import { getTitleByPartner } from '../lib/getTitleByPartner';
const Title: FC = () => {
  const {
    partner
  } = usePartner();
  const title = getTitleByPartner(partner);
  return <Text>{title}</Text>;
};
export default Title;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.md;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1kls8r4",
  propsAsIs: false,
  vars: {
    "t1kls8r4-0": [_exp()],
    "t1kls8r4-1": [_exp2(), "px"],
    "t1kls8r4-2": [_exp3()],
    "t1kls8r4-3": [_exp4()],
    "t1kls8r4-4": [_exp5(), "px"],
    "t1kls8r4-5": [_exp6(), "px"],
    "t1kls8r4-6": [_exp7(), "px"]
  }
}));

require("./Title.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Title.tsx");